$('.slider').slick({
    rows: 0,
    arrows: true,
    prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Slider control: previous" rel="nofollow"><i class="far fa-chevron-left"></i></a>',
    nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Slider control: next" rel="nofollow"><i class="far fa-chevron-right"></i></a>',
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    speed: 300,
    lazyLoad: 'ondemand',
    adaptiveHeight: false,
    customPaging: function (slick, index) {
        return '<button type="button" id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></button>';
    },
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        },{
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },{
            breakpoint: 580,
            settings: {
                slidesToShow: 1,
                adaptiveHeight: true
            }
        }
    ]
});

$('.products--small .slider').slick('slickSetOption', {
    slidesToShow: 6
}, true);

$('.product-gallery').each(function () {
    let $wrapper = $(this),
        $galleryMain = $(this).find('.product-gallery__main'),
        $galleryThumbs = $(this).find('.product-gallery__thumbs');

    $galleryMain.on('init', function () {
        $wrapper.addClass('product-gallery--initialized');
    }).slick({
        rows: 0,
        arrows: false,
        prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Gallery main slider control: previous" rel="nofollow"><i class="far fa-chevron-left"></i></a>',
        nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Gallery main slider control: next" rel="nofollow"><i class="far fa-chevron-right"></i></a>',
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        infinite: false,
        speed: 300,
        lazyLoad: 'ondemand',
        asNavFor: $galleryThumbs
    });

    $galleryThumbs.slick({
        rows: 0,
        arrows: true,
        prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Gallery thumbs slider control: previous" rel="nofollow"><i class="far fa-chevron-left"></i></a>',
        nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Gallery thumbs slider control: next" rel="nofollow"><i class="far fa-chevron-right"></i></a>',
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        infinite: true,
        centerMode: true,
        speed: 300,
        lazyLoad: 'ondemand',
        focusOnSelect: true,
        asNavFor: $galleryMain,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
});

$('.cards__slider').slick({
    rows: 0,
    arrows: true,
    prevArrow: '<a href="#" class="slick-control slick-control--prev" title="Vorige" data-gtm-event="Slider control: previous" rel="nofollow"><i class="far fa-chevron-left"></i></a>',
    nextArrow: '<a href="#" class="slick-control slick-control--next" title="Volgende" data-gtm-event="Slider control: next" rel="nofollow"><i class="far fa-chevron-right"></i></a>',
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    speed: 300,
    lazyLoad: 'ondemand',
    adaptiveHeight: false,
    customPaging: function (slick, index) {
        return '<button type="button" id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></button>';
    },
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        },{
            breakpoint: 701,
            settings: {
                slidesToShow: 1,
                adaptiveHeight: true
            }
        }
    ]
}).on( 'click', '.slick-slide', function(e) {
    let $slider = $(this).closest('.slick-slider');

    if (!$(this).hasClass('slick-active')) {
        e.preventDefault();

        // check if slide is before or after active slides
        if ($(this).prevAll('.slick-active').length > 0) {
            // console.log('element comes after active');
            $slider.slick('slickNext');
        } else {
            // console.log('element comes before active');
            $slider.slick('slickPrev');
        }
    }
});
